/**
 * Convert a saved TripReport to a TripReportDraft for editing.
 *
 * When `report_id` is present in the draft, the ReviewEditScreen
 * uses PUT instead of POST to update the existing report.
 */

import type { TripReport, TripReportDraft } from "../types";

export function reportToDraft(report: TripReport): TripReportDraft {
  return {
    report_id: report.id,
    account_name: report.account_name,
    other_companies_mentioned: report.other_companies_mentioned ?? [],
    account_uuid: report.account_uuid,
    account_resolution_label: null,
    visit_date: report.visit_date,
    visit_type: report.visit_type,
    salesperson_name: report.salesperson_name,
    attendees: report.attendees ?? [],
    topics: report.topics ?? [],
    action_items: report.action_items ?? [],
    competitors_mentioned: report.competitors_mentioned ?? [],
    contact_updates: report.contact_updates ?? [],
    detected_order: {
      has_order: false,
      confidence: 0,
      line_items: [],
      ship_to: null,
      po_number: null,
      notes: null,
    },
    overall_sentiment: report.overall_sentiment,
    confidence: report.confidence,
    raw_transcript: report.raw_transcript,
  };
}
